import React, { useMemo, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";

import {
  HvTableColumnConfig,
  useHvTable,
} from "@hitachivantara/uikit-react-lab";

import SimpleTable, {
  badgeColumn,
  numberColumn,
  switchColumn,
} from "components/common/SimpleTable";

import { populateMasterData, Priority, usePriorities } from "lib/api";

const IncidentPriorityTable: React.FC = () => {
  const { t } = useTranslation("incidentPriority");
  const { data, mutate } = usePriorities();

  useEffect(() => {
    if (data && data.data && data.data.length === 0) {
      (async () => {
        await populateMasterData();
        await mutate();
      })();
    }
  }, [data, mutate]);

  const columns = useMemo(
    (): HvTableColumnConfig<Priority>[] => [
      numberColumn({
        Header: t("columns.order") as string,
        accessor: "inc_priority_order",
        style: { width: 100 },
      }),
      badgeColumn(
        {
          Header: t("columns.name") as string,
          accessor: "prt_name",
          style: { width: "20%" },
        },
        "P",
        "inc_priority_order",
        "prt_color",
        "prt_name",
        true
      ),
      switchColumn(
        {
          Header: t("columns.default") as string,
          accessor: "prt_is_default",
        },
        t("columns.default"),
        t("labels.no"),
        t("labels.yes")
      ),
    ],
    [t]
  );

  const instance = useHvTable<Priority>({
    columns,
    data: data?.data || [],
    getRowId: useCallback((v: Priority): string => `${v.pk_prt_id}`, []),
  });

  return data ? (
    <SimpleTable
      instance={instance}
      totalCount={data?.totalCount}
      disableSelection
      disablePagination
    />
  ) : null;
};

export default IncidentPriorityTable;
